import React, { useState } from "react";
import { Button, MenuItem, TextField, Typography } from "@mui/material";
import _ from "lodash";
import { MAX_NOTIFY_AFTER_MINUTES, NOTIFY_AFTER_OPTIONS } from "../types/alertRule/alertRuleConstants";

const CUSTOM = "custom";
const isPreset = (seconds) => _.some(NOTIFY_AFTER_OPTIONS, { value: Number(seconds || 0) });

// «Avisar» de un destinatario: de inmediato o después de X minutos con el problema sin resolver (lo comparten las reglas
// y «Conexión de equipos»). «Otro…» pide los minutos; mientras no sirvan, entrega null.
const NotifyAfterField = ({ value, onChange }) => {
    const [custom, setCustom] = useState(!isPreset(value));
    const [minutes, setMinutes] = useState(`${Math.round((Number(value) || 0) / 60)}`);

    if (custom) {
        const number = Number(minutes);
        const valid = minutes !== "" && Number.isInteger(number) && number >= 0 && number <= MAX_NOTIFY_AFTER_MINUTES;
        return (
            <TextField
                fullWidth
                type="number"
                label="Avisar después de"
                value={minutes}
                onChange={(event) => {
                    const next = event.target.value;
                    const nextNumber = Number(next);
                    setMinutes(next);
                    const ok = next !== "" && Number.isInteger(nextNumber) && nextNumber >= 0 && nextNumber <= MAX_NOTIFY_AFTER_MINUTES;
                    onChange(ok ? nextNumber * 60 : null);
                }}
                error={!valid}
                helperText={valid ? (
                    <Button size="small" sx={{ p: 0, minWidth: 0, textTransform: "none" }}
                            onClick={() => { setCustom(false); onChange(0); }}>
                        Ver opciones
                    </Button>
                ) : "Minutos enteros"}
                InputProps={{ endAdornment: <Typography variant="caption" color="text.secondary">min</Typography> }}
                inputProps={{ min: 0, max: MAX_NOTIFY_AFTER_MINUTES, step: 1 }}
            />
        );
    }

    return (
        <TextField
            fullWidth
            select
            label="Avisar"
            value={`${Number(value) || 0}`}
            onChange={(event) => {
                if (event.target.value === CUSTOM) {
                    setMinutes(`${Math.round((Number(value) || 0) / 60)}`);
                    setCustom(true);
                } else {
                    onChange(Number(event.target.value));
                }
            }}>
            {_.map(NOTIFY_AFTER_OPTIONS, (option) => (
                <MenuItem key={`notify-after-${option.value}`} value={`${option.value}`}>{option.label}</MenuItem>
            ))}
            <MenuItem value={CUSTOM}>Otro…</MenuItem>
        </TextField>
    );
};

export default NotifyAfterField;
